import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { UserService } from '../../services/user-service/user.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-profile-information',
    standalone: true,
    imports: [RouterLink, MatCardModule, MatButtonModule, MatMenuModule,NgIf],
    templateUrl: './profile-information.component.html',
    styleUrl: './profile-information.component.scss'
})
export class ProfileInformationComponent implements OnInit {
    
    user: any = {}; // Stockera les données de l'utilisateur
    constructor(private userService:UserService){}

    ngOnInit(): void {
        console.log("User ID from session:", sessionStorage.getItem('user_id'));
        this.loadUser();
      }
      
      loadUser() {
        const userId = sessionStorage.getItem('user_id');
    
        if (userId) {
          const numericUserId = parseInt(userId, 10);
    
          if (!isNaN(numericUserId)) {
            console.log("Fetching user with ID:", numericUserId);
    
            this.userService.getUserById(numericUserId).subscribe({
              next: (userData) => { // userData est maintenant un `AppUserDTO`
                console.log("User data received:", userData);
                this.user = userData; // Pas besoin d'accéder à `.data`, car c'est déjà extrait
              },
              error: (err) => {
                console.error("Erreur lors de la récupération de l'utilisateur :", err);
              }
            });
          } else {
            console.error("L'ID utilisateur n'est pas valide.");
          }
        } else {
          console.error("Aucun ID utilisateur trouvé en session.");
        }
    }
    
      
    
    // Méthode pour mapper les rôles en labels plus lisibles
    mapRole(role: string | null): string {
        if (!role) return 'Utilisateur'; // Valeur par défaut
        const roleMappings: { [key: string]: string } = {
            'ROLE_ROLE_ADMIN': 'Administrateur',
            'ROLE_ROLE_WORKER': 'Worker',
            'ROLE_ROLE_USER': 'Utilisateur',
            'ROLE_ROLE_MANAGER': 'Manager',
        };
        return roleMappings[role] || 'Utilisateur'; // Si le rôle est inconnu, afficher "Utilisateur"
    }
}
